import { render, staticRenderFns } from "./LocationCards.vue?vue&type=template&id=19c20e81&scoped=true&"
import script from "./LocationCards.vue?vue&type=script&lang=js&"
export * from "./LocationCards.vue?vue&type=script&lang=js&"
import style0 from "./LocationCards.vue?vue&type=style&index=0&id=19c20e81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c20e81",
  null
  
)

export default component.exports